import { useRef } from 'react';
import { Popover, Button, Input } from '@ets/design-system';
import { FormattedMessage } from 'react-intl';

import styles from './SettingsCell.module.scss';

type SettingsCellProps = {
  object: Objekt;
};

const SettingsCell = ({ object }: SettingsCellProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const getPublicLink = () => {
    return `${window.location.origin}/public/${object.type}/${object.hash}`;
  };

  const handleOnCopyLink = () => {
    inputRef.current?.select();
    inputRef.current && navigator.clipboard.writeText(inputRef.current.value);
  };

  return (
    <>
      <Popover.Root placement="bottom-end">
        <Popover.Trigger asChild>
          <Button variant="link" size="s" testId="public-link-row-copy">
            <FormattedMessage id="settings.publicLink.copyLink" />
          </Button>
        </Popover.Trigger>
        <Popover.Content testId="public-link-copy">
          <div
            className={styles.popover}
            style={{
              display: 'flex',
              padding: '0 2rem',
            }}
          >
            <Input
              value={getPublicLink()}
              ref={inputRef}
              size="m"
              testId="public-link-row-copy"
              placeholder=""
              isClearVisible={false}
            />
            <Button
              size="m"
              variant="primary"
              onClick={handleOnCopyLink}
              testId="public-link-row-copy-clipboard"
              style={{ margin: '0 0 0 1rem' }}
            >
              <FormattedMessage id="global.copyToClipboard" />
            </Button>
          </div>
        </Popover.Content>
      </Popover.Root>
    </>
  );
};

export default SettingsCell;
